import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useGlobalState } from '../../../common/context/AppContext';
import ChatIcon from '../chat-icon/ChatIcon';
import { WhiteLabel } from '../white-label/WhiteLabel';
import { baseStyles } from '../../../theme/base.styles';
import { useStyles } from './GridWrapper.styles';

interface IProps {
    header?: string;
    showChatIcon?: boolean;
    children?: React.ReactNode | string;
    className?: string;
}

export const GridWrapper = ({ children, header, className, showChatIcon = true }: IProps): JSX.Element => {
    const classes = useStyles();
    const { partner } = useGlobalState();
    return (
        <Grid item md={12} xs={12} className={`${classes.item}${className && ` ${className}`}`}>
            {header && <Header>{header}</Header>}
            {showChatIcon && <ChatIcon />}
            {children}
            <WhiteLabel partner={partner} />
        </Grid>
    );
};

interface IHeader {
    children: string;
}

const Header = ({ children }: IHeader): JSX.Element => {
    const baseClasses = baseStyles();
    return (
        <Typography variant="h1" color="textPrimary" className={baseClasses.h1}>
            {children}
        </Typography>
    );
};

export default GridWrapper;
